import { Components, selectClasses, Theme } from '@mui/material';
import { inputBaseClasses } from '@mui/material/InputBase';

import { ArrowDown } from '../../../icons';

export function getMuiSelect(theme: Theme): Components['MuiSelect'] {
  return {
    defaultProps: {
      variant: 'standard',
      IconComponent: props => <ArrowDown {...props} />,
    },
    styleOverrides: {
      select: {
        textTransform: 'none',
        fontFeatureSettings: "'case' on, 'cv11' on, 'calt' off",
        boxShadow: 'none',
        fontSize: 16,
        fontWeight: 400,
        lineHeight: 1.4,
        letterSpacing: '-0.01em',
        color: theme.palette.grey[600],

        [`&:hover , &[aria-expanded="true"], &:hover ~ .${selectClasses.icon}, &[aria-expanded="true"] ~ .${selectClasses.icon}`]:
        {
          color: theme.palette.grey[900],
        },

        [`&&&.${selectClasses.error} ~ .${selectClasses.icon}`]:
        {
          color: theme.palette.grey[600],
        },

        [`&.${selectClasses.disabled}, &.${selectClasses.disabled} ~ .${selectClasses.icon}`]:
        {
          color: theme.palette.grey[600],
        },

        [`&&.${selectClasses.error}`]:
        {
          color: theme.palette.text.primary,
        },

        '&&': {
          margin: 0,
        },

        '&:focus': {
          backgroundColor: 'unset',
        },

        [`& .${inputBaseClasses.root}`]: {
          padding: 0,
        },
      },

      icon: {
        top: 'unset',
        right: theme.spacing(2),
        transition: '0.25s',
      },
    },
  };
}
